var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHandwritten = function SvgHandwritten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.48 35H8.062A7.06 7.06 0 0 1 1 27.938V8.728c0-3.9 3.162-7.061 7.062-7.061h19.21c3.9 0 7.061 3.161 7.061 7.062v13.524M8.062 9.152h19.227M8.062 14.802H27.27M8.062 20.452h5.085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M33.237 33.904a3.743 3.743 0 0 0 0-5.293l-4.951-4.952a8.8 8.8 0 0 0-4.499-2.407l-4.002-.8.8 4.002a8.8 8.8 0 0 0 2.408 4.499l4.95 4.95a3.743 3.743 0 0 0 5.294 0"
  })));
};
export default SvgHandwritten;